import React from 'react';

const Layout = ({ children, className = '', hideHeader = false }) => {
  return (
    <div className={`layout-container ${className}`}>
      <div className="account-card" style={{paddingBottom: '20px'}}>
        {/* Header with logos and title */}
        <div className="account-header" style={hideHeader ? { visibility: 'hidden' } : undefined}>
          <h1 className="study-title">FAST-TRACK HIP</h1>
          <div className="login-logo">
            <img src="/images/logo_charite.svg" alt="Charité Logo" className="logo-charite" />
            <span className="logo-separator">×</span>
            <img src="/images/logo_bw.svg" alt="BW Logo" className="logo-bw" />
          </div>
        </div>
      </div>
      
      {children}
    </div>
  );
};

export default Layout; 